export default "__VITE_ASSET__fjT7B8Gz__"